<router-outlet />
<ngx-spinner type="ball-clip-rotate" size="large" color="#fff" bdColor="rgba(0, 0, 0, 0.5)">
  <p style="color: white">Procesando solicitud...</p>
</ngx-spinner>
<p-toast [preventOpenDuplicates]="false" />
<p-toast key="global-message" [preventOpenDuplicates]="true" />
<p-confirmdialog
  key="avisoDialog"
  [draggable]="false"
  [styleClass]="'max-w-[400px] min-w-[300px] mx-[16px]'" />
<p-confirmDialog #logoutDialog key="logoutDialog">
  <ng-template pTemplate="headless" let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="flex flex-col items-center p-8 bg-surface-0 rounded">
      <div
        class="rounded-full bg-primary text-primary-contrast inline-flex justify-center items-center h-24 w-24 -mt-20">
        <i class="pi pi-question text-5xl!"></i>
      </div>
      @if (message?.header) {
        <span class="font-bold text-2xl block mb-2 mt-6" [innerHTML]="message.header"></span>
      }
      @if (message?.message) {
        <p class="mb-0" [innerHTML]="message.message"></p>
      }
      <div class="flex items-center gap-2 mt-6">
        <p-button label="Aceptar" (onClick)="onAccept()" class="w-32"></p-button>
        <p-button label="Cancelar" [outlined]="true" (onClick)="onReject()" class="w-32"></p-button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
